<template>
  <el-form-item :label="label" :for="id" :prop="id">
    <el-select :id="id" v-bind="$attrs" :value="value" @change="change" @input="input">
      <el-option v-for="option in options" :key="option.id" :label="option.label" :value="option.value" />
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'InputDropdown',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value);
    },
    change(value) {
      this.$emit('change', value);
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-input) {
  font-size: 16px;
}
</style>
